<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="row mt-2">
                <div class="col-md-12">
                  <button
                    type="submit"
                    @click="handleForm"
                    class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                  >
                    <i class="material-symbols-outlined">check</i>
                    Edit User
                  </button>
                  <!-- <router-link
                    class="btn btn-outline-danger btn-no-outline float-right"
                    to="/master/user"
                    >Batalkan</router-link
                  > -->
                  <a
                    class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                    @click="() => goBack('/master/user')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
import { roles } from "@/store/index.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
let data = {
  title: "Edit User",
  backBtn: "/master/user",
  actionBtn: [],
  breadcrumb: [
    { title: "User", link: "/master/user" },
    { title: "Edit User", active: true },
  ],
};

export default {
  name: "UserEdit",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: [
        {
          colnum: 1,
          columns: [
            {
              name: "name",
              type: "text",
              label: "Nama",
              colwidth: 8,
              value: "",
            },
          ],
        },
        {
          colnum: 1,
          columns: [
            {
              name: "email",
              type: "email",
              label: "Email",
              colwidth: 8,
              value: "",
            },
          ],
        },
        {
          colnum: 1,
          columns: [
            {
              name: "role",
              type: "select",
              label: "Role",
              colwidth: 8,
              options: roles,
              value: "",
            },
          ],
        },
        //         {
        //   colnum: 1,
        //   columns: [
        //     { name: "id_dokter", type: "select", label: "Dokter",colwidth:8,options:[],value:"",mandatory:false,optional:true},
        //   ]
        // },
        // {
        //   colnum: 1,
        //   columns: [
        //     { name: "id_petugas", type: "select", label: "Petugas",colwidth:8,options:[],value:"",mandatory:false,optional:true},
        //   ]
        // },
      ],
      formSet: {
        password: "",
        name: "",
        email: "",
        role: "",
        id_dokter: "",
        id_petugas: "",
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      let params = "";
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          //console.log(key);
          //console.log(self.formSet[key]);
          formData.append(key, self.formSet[key]);
          params += key + "=" + self.formSet[key] + "&";
        });
        try {
          let result = await this.$store.state.HTTP_ENC.put(
            `user/${this.$route.params.id}?${params}`
          );
          //console.log(formData);
          //console.log(result);
          if (result.status == "200") {
            this.$router.push(`/master/user`);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    updateForm() {
      let self = this;
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (self.formSet[column.name]) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get("dokter");
        if (result.status == "200") {
          //console.log(result);
          let doctors = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[3].columns[0].options = doctors;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get("petugas");
        if (result.status == "200") {
          //console.log(result);
          let nurses = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[4].columns[0].options = nurses;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `user/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          let self = this;
          this.data.breadcrumb[1].title = `${result.data.name} [ ${result.data.email} ]  / Edit User`;
          Object.keys(this.formSet).forEach(function(key) {
            self.formSet[key] = result.data[key];
          });
          //console.log(self.formSet);
          this.updateForm();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
    },
    fetchUnits: async function() {
      try {
        let result = await this.$store.state.HTTP.get("unit");
        if (result.status == "200") {
          //console.log(result);
          let units = result.data.data.map((item) => {
            item.label = item.formatted_unit;
            item.value = item.id;
            return item;
          });
          this.leftForm[0].columns[0].options = units;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
      this.updateForm();
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      return valid;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    // await this.fetchDoctors();
    // await this.fetchNurses();
    this.displayData();
  },
};
</script>
